import Vue from "vue";
import Router from "vue-router";
import store from "./store";
import HostLoginPage from "./views/HostLoginPage.vue";
import SideNav from "./components/SideNav.vue";

import { intersection, startCase } from "lodash";
import { access } from "./mixins/constant";

Vue.use(Router);

let router = new Router({
  base: process.env.BASE_URL,
  mode: "history",
  routes: [
    {
      path: "/side-nav",
      name: "sideNav",
      component: SideNav,
      children: [
        {
          path: "/profile-update",
          name: "profileUpdate",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ProfileUpdate.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/my-account",
          name: "myAccount",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/MyAccount.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/dashboard",
          name: "dashboard",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Dashboard.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          // path: '/upload-recommendation/:reco_id?/:duration?/:stock_name?',
          path: "/upload-recommendation/:stock_name?",
          name: "uploadRecommendation",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/UploadRecommendation.vue"),
          props(route) {
            return route.params || {};
          },
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/past-recommendations",
          name: "pastRecommendations",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/PastRecommendations.vue"),
          props(route) {
            return route.params || {};
          },
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/expert-view-lite",
          name: "OpenExpertViewLite",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/OpenExpertViewLite.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/my-dashboard",
          name: "myDashboard",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/UserDashboard.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/expert-list",
          name: "ExpertChat",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/chatExpertListPage.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/expert-store",
          name: "expertStore",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ExpertStore.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/expert-dashboard",
          name: "expertDashboard",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ExpertDashboard.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/dashboard-analytics",
          name: "dashboardAnalytics",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/DashboardAnalytics.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/stockants-dashboard-analytics",
          name: "stockAntsDashboardAnalytics",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/SADashboardAnalytics.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/experts-past-recommendations/:stock_id?/:user_id?/:sector?/:cap?/",
          name: "expertsPastRecommendations",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ExpertsPastRecommendations.vue"),
          props(route) {
            return route.params || {};
          },
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },

        {
          path: "/equity-watchlist",
          name: "equityWatchlist",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/EquityWatchlist.vue"),
          props(route) {
            return route.params || {};
          },
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },

        {
          path: "/options-watchlist",
          name: "optionsWatchlist",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/OptionsWatchlist.vue"),
          props(route) {
            return route.params || {};
          },
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/experts-past-recommendations-v2/:stock_id?/:user_id?/:sector?",
          name: "expertsPastRecommendationsV2",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ExpertPastRecoV2.vue"),
          props(route) {
            return route.params || {};
          },
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/pricing/:method?",
          name: "pricing",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Pricing.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
          props(route) {
            return route.params || {};
          },
        },

        {
          path: "/trading/:orders?",
          name: "trading",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Trading.vue"),
          props(route) {
            return route.params || {};
          },
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },

        {
          path: "/publish-recommendation-options",
          name: "PublishRecommendationOptions",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/PublishRecommendationOptions.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/expert-buzz/:post_id?",
          name: "ExpertBuzz",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ExpertBuzz.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
          props(route) {
            return route.params || {};
          },
        },
        {
          path: "/my-posts",
          name: "MyPost",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/MyPosts.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
          props(route) {
            return route.params || {};
          },
        },
        {
          path: "/expert-past-strategy-options",
          name: "ExpertsPastStrategyOptions",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ExpertsPastStrategyOptions.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/past-strategy-options",
          name: "PastStrategyOptions",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/PastStrategyOption.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },

        {
          path: "/stockants-overview",
          name: "StockAntsOverview",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/StockAntsOverview.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },
        {
          path: "/data-categorisation",
          name: "DataCategorisation",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/DataCategorisation.vue"),
          meta: {
            access: [
              access.ALL,
              access.BROKER,
              access.ANALYST,
              access.FINANCIAL_ADVISER,
              access.NON_FINANCE,
              access.OTHER,
              access.STUDENT,
              access.RETAIL_INVESTOR,
              access.MARKET_EXPERT,
              access.DEALER,
              access.ADMIN,
            ],
          },
        },

        {
          path: "/change-password",
          name: "ChangePassword",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ChangePassword.vue"),
        },
        {
          path: "/broker-disclaimer",
          name: "BrokerDisclaimer",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/BrokerDisclaimer.vue"),
        },
        {
          path: "/markets-overview",
          name: "marketsOverview",
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Markets.vue"),
          props(route) {
            return route.params || {};
          },
        },
      ],
    },

    // for general all login
    {
      path: "/login",
      name: "login",
      component: HostLoginPage,
      props(route) {
        return route.params || {};
      },
    },

    // for general all login
    {
      path: "/paytm-login",
      name: "PaytmLogin",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/PaytmMoneyLogin.vue"),
      props(route) {
        return route.params || {};
      },
      // meta: {
      //   access: [access.USER]
      // }
    },
    {
      path: "/auth-bypass",
      name: "DailyGongLogin",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AuthBypassLogin.vue"),
      props(route) {
        return route.params || {};
      },
      // meta: {
      //   access: [access.USER]
      // }
    },

    {
      path: "/verify-otp/:key?",
      name: "verifyOtp",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/OtpVerification.vue"),
      props(route) {
        return route.params || {};
      },
    },
    {
      path: "/verify-user",
      name: "verifyUser",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BypassUserVerification.vue"),
      props(route) {
        return route.params || {};
      },
    },
    {
      path: "/forgot-password",
      name: "forgotPassword",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/ForgotPassword.vue"),
    },
    {
      path: "/set-new-password",
      name: "setNewPassword",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("./views/SetNewPassword.vue"),
    },

    {
      path: "/stockants-compliance",
      name: "StockAntsCompliance",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/StockAntsCompliance.vue"),
    },
    {
      path: "/stockants-compliance-experts",
      name: "StockAntsComplianceExperts",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/StockantsComplianceExperts.vue"),
    },
    {
      path: "/widget-stockants-compliance",
      name: "WidgetStockAntsCompliance",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/StockAntsWidgets/WidgetStockAntsComplaince.vue"),
    },

    // pre sign up expert view
    {
      path: "/",
      name: "PreSignUpRecoView",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/OpenExpertView.vue"),
      props(route) {
        return route.params || {};
      },
    },
    {
      path: "/options/expert-view",
      name: "PreSignUpMarketStrategy",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/MarketStrategyPreLogin.vue"),
      props(route) {
        return route.params || {};
      },
    },

    {
      path: "/business-partners",
      name: "BecomeBusinessPartners",
      component: () => import("./views/BecomeBusinessPartners.vue"),
    },

    {
      path: "/retail-investors",
      name: "RetailSideLandingPage",
      component: () => import("./views/NewRetailLandingPage.vue"),
    },

    {
      path: "/retail-side/terms-condition",
      name: "RetailSideTermsAndCondition",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RetailSidePages/FinTermsAndCondition.vue"),
    },
    {
      path: "/retail-side/faq",
      name: "RetailSideFAQ",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RetailSidePages/retailSideFaq.vue"),
    },
    {
      path: "/retail-side/refer-earn",
      name: "RetailSideReferAndEarn",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RetailSidePages/FinReferAndEarn.vue"),
    },
    {
      path: "/retail-side/about-us",
      name: "RetailSideAboutUs",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RetailSidePages/AboutUs.vue"),
    },
    {
      path: "/retail-side/privacy-policy",
      name: "RetailSidePrivacyPolicy",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RetailSidePages/PrivacyPolicy.vue"),
    },
    {
      path: "/retail-side/disclaimer",
      name: "RetailSideDisclaimer",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RetailSidePages/Disclaimer.vue"),
    },
    {
      path: "/retail-side/racp",
      name: "RetailSideRefundAndCancelation",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RetailSidePages/RefundAndCancellation.vue"),
    },
    {
      path: "/retail-side/contact-us",
      name: "RetailSideContactUs",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/RetailSidePages/contactUs.vue"),
    },

    // advisors side pages list
    // {
    //   path: "/advisors/expert-side",
    //   name: "AdvisorSideExpertLanding",
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/AdvisorsExpertSidePages/AdvisorsExpertLandingPage.vue"),
    // },
    {
      path: "/advisors/expert-side/terms-condition",
      name: "AdvisorSideExpertTermsAndCondition",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AdvisorsExpertSidePages/TermsAndCondition.vue"),
    },
    {
      path: "/advisors/expert-side/faq",
      name: "AdvisorSideExpertFAQ",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AdvisorsExpertSidePages/Faq.vue"),
    },
    {
      path: "/advisors/expert-side/about-us",
      name: "AdvisorSideExpertAboutUs",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AdvisorsExpertSidePages/AboutUs.vue"),
    },
    {
      path: "/advisors/expert-side/privacy-policy",
      name: "AdvisorSideExpertPrivacyPolicy",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AdvisorsExpertSidePages/PrivacyPolicy.vue"),
    },
    {
      path: "/advisors/expert-side/disclaimer",
      name: "AdvisorSideExpertDisclaimer",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AdvisorsExpertSidePages/Disclaimer.vue"),
    },
    {
      path: "/advisors/expert-side/racp",
      name: "AdvisorSideExpertRefundAndCancelation",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AdvisorsExpertSidePages/RefundAndCancellation.vue"),
    },
    {
      path: "/advisors/expert-side/contact-us",
      name: "AdvisorSideExpertContactUs",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/AdvisorsExpertSidePages/contactUs.vue"),
    },

    // brokers side pages list
    {
      path: "/brokers/expert-side",
      name: "BrokerSideExpertLandingpage",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokersExpertSidePages/BrokersExpertlandingPage.vue"),
    },
    {
      path: "/brokers/expert-side/terms-condition",
      name: "BrokerSideExpertTermsAndCondition",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokersExpertSidePages/TermsAndCondition.vue"),
    },
    {
      path: "/brokers/expert-side/refer-earn",
      name: "BrokerSideExpertReferAndEarn",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokersExpertSidePages/ReferAndEarn.vue"),
    },
    {
      path: "/brokers/expert-side/about-us",
      name: "BrokerSideExpertAboutUs",
      component: () =>
        import(/* webpackChunkName: /Market"about" */ "./views/BrokersExpertSidePages/AboutUs.vue"),
    },
    {
      path: "/brokers/expert-side/privacy-policy",
      name: "BrokerSideExpertPrivacyPolicy",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokersExpertSidePages/PrivacyPolicy.vue"),
    },
    {
      path: "/brokers/expert-side/disclaimer",
      name: "BrokerSideExpertDisclaimer",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokersExpertSidePages/Disclaimer.vue"),
    },
    {
      path: "/brokers/expert-side/racp",
      name: "BrokerSideExpertRefundAndCancelation",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokersExpertSidePages/RefundAndCancellation.vue"),
    },
    {
      path: "/brokers/expert-side/contact-us",
      name: "BrokerSideExpertContactUs",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokersExpertSidePages/contactUs.vue"),
    },
    {
      path: "/performers",
      name: "Performers",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/Performers.vue"),
    },
    {
      path: "/market-sentiment",
      name: "MarketSentimentCard",
      component: () =>
        import(/* webpackChunkName: "about" */ "./components/MarketSentimentCard.vue"),
    },
    {
      path: "/broker/disclaimer",
      name: "BrokerDisclaimerPreSignUp",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/BrokerDisclaimerPreSignUp.vue"),
    },
    // StockAnts Widget
    {
      path: "/equity-insights/:stock?/:broker_access_key?/",
      name: "EquityInsights",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/StockAntsWidgets/WidgetEquityView.vue"),
      props(route) {
        return route.params || {};
      },
    },
    {
      path: "/options-insights/:indice?/:broker_access_key?/",
      name: "OptionsInsights",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/StockAntsWidgets/WidgetOptionsView.vue"),
      props(route) {
        return route.params || {};
      },
    },
    {
      path: "/market-sentiment-widget/:stock_code?/",
      name: "WidgetMarketSentiment",
      component: () =>
        import(/* webpackChunkName: "about" */ "./components/StockAntsLiteWidgets/WidgetSentimentCard.vue"),
      props: (route) => ({
        stock_code: route.query.stock_code,
        broker_access_key: route.query.broker_access_key,
      }),
    },
    {
      path: "/widget-sa-disclaimer",
      name: "WidgetStockAntsDisclaimer",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/StockAntsWidgets/WidgetStockAntsDisclaimer.vue"),
    },
    {
      path: "/widget-broker-disclaimer",
      name: "WidgetBrokerDisclaimer",
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/StockAntsWidgets/WidgetBrokerDisclaimer.vue"),
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.commit("commitSubscribPlanDialogVisibility", false); //on any route change hide paid feature dialog
  const currentEnvironment = localStorage.getItem("currentEnvironment")
    ? JSON.parse(localStorage.getItem("currentEnvironment"))
    : {};

  if (to.meta && to.meta.access) {
    // console.log('step 1 check what is comming',to.path);

    try {
      var authorized_to = to.meta.access;
      var roles = JSON.parse(localStorage.getItem("roles"));
      if (roles) {
        var user_access_permissions = roles.map((item) => item);
      }
      var access_granted = intersection(user_access_permissions, authorized_to);

      if (access_granted.length) {
        console.log("Authorized access");

        let route_name = localStorage.getItem("route_to_be");
        let userPlanDetails = JSON.parse(localStorage.getItem("plan_details"));

        if (route_name && to.path != "/profile-update") {
          // if route_to_be is pricing but user have already subscribed pre or pro then redirect to expert view
          if (route_name == "/pricing") {
            if (
              userPlanDetails.plan != "Premium" &&
              userPlanDetails.plan != "Pro"
            ) {
              route_name = "/pricing";
            } else {
              route_name = "/data-categorisation";
            }
          }

          // set selected market type as options when options route found
          if (
            to.path == "/expert-past-strategy-options" ||
            to.path == "/publish-recommendation-options" ||
            to.path == "/past-strategy-options"
          ) {
            localStorage.setItem("market_type", "options");
          }

          localStorage.removeItem("route_to_be");
          // next({path : route_name});

          window.location.href = route_name;
        } else {
          next();
        }
      } else {
        console.log("Un-Authorized access");
        var token = localStorage.getItem("token");
        // if user has token and not filled profile yet and trying to access other pages then he will redirect to profile page only
        if (token && from.name == "profileUpdate") {
          next({
            name: "profileUpdate",
          });
        } else {
          localStorage.clear(true);

          localStorage.setItem("route_to_be", to.fullPath);
          next({
            name: "login",
          });
        }
      }
    } catch (e) {
      console.log("EXCEPTION: error parsing roles from storage...", e);
      localStorage.clear(true);
      next({
        name: "login",
      });
    }

    if (to.path === "/pricing" && currentEnvironment.loginModule == "BlinkX") {
      next({
        name: "expertsPastRecommendations",
      });
    } else {
      next(); // Proceed with the navigation
    }
  } else {
    console.log("open route...");
    if (to.name === "login") {
      console.log("login route found in to");
      try {
        var token = localStorage.getItem("token");
        if (token) {
          if (from.name == "profileUpdate") {
            next({
              name: "profileUpdate",
            });
          } else {
            //auto redirect to dahsboard page
            console.log("auto login redirecting to home...");
            next({
              name: "expertsPastRecommendations",
            });
          }
        } else {
          // Check currentEnvironment and redirect if necessary
          if (localStorage.getItem("currentEnvironment")) {
            if (
              currentEnvironment.utm_source &&
              (currentEnvironment.utm_source === "Nirman" ||
                currentEnvironment.utm_source === "Choice" ||
                currentEnvironment.loginModule === "BlinkX")
            ) {
              return next("/");
            } else if (currentEnvironment.byPassLogin) {
              return next("/auth-bypass");
            }
          }
          // Go to login page if no special conditions are met
          console.log("old login session not present...");
          next();
        }
      } catch (e) {
        //continue to login page
        console.log("exception getting login session...", e);
        next();
      }
    } else if (to.name === "PreSignUpMarketOpinion") {
      if (localStorage.getItem("currentEnvironment")) {
        if (currentEnvironment.byPassLogin) {
          return next("/auth-bypass");
        }
      }
      // Go to login page if no special conditions are met
      next();
    } else if (to.name === "verifyOtp") {
      console.log("login route found in to");
      try {
        var token = localStorage.getItem("token");
        if (token) {
          if (from.name == "profileUpdate") {
            next({
              name: "profileUpdate",
            });
          } else {
            //auto redirect to dashboard page
            console.log("auto login redirecting to home...");
            next({
              name: "expertsPastRecommendations",
            });
          }
        } else {
          //go to login page
          console.log("old login session not present...");
          next();
        }
      } catch (e) {
        //continue to login page
        console.log("exception getting login session...", e);
        next();
      }
    } else {
      next();
    }
  }
});
router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
